// extracted by mini-css-extract-plugin
module.exports = {"container":"TooltipContainer_container__36Lf_","content":"TooltipContainer_content__3ixyh","sending":"TooltipContainer_sending__1uzKv"};